import React from 'react';
export function Footer() {
  return <footer className="bg-[var(--bg-2)] border-t border-[var(--border)] py-8 pb-6 md:py-12 md:pb-8 px-6" data-id="element-61">
      <div className="max-w-[1200px] mx-auto" data-id="element-62">
        <div className="flex flex-col items-center text-center gap-6" data-id="element-63">
          <a href="#" className="flex items-center gap-2.5 no-underline" aria-label="Oriam Marketing" data-id="element-64">
            <img src="https://cdn.magicpatterns.com/uploads/3yb7f5d7uQWjVx1ZxJha8Z/2_(2).png" alt="Oriam Marketing" className="h-8 w-auto" data-id="element-65" />
          </a>

          <p className="text-sm text-[var(--text-muted)] leading-[1.65] max-w-[500px]" data-id="element-66">
            Creamos páginas web profesionales con inteligencia artificial
            integrada para negocios locales que quieren vender online.
          </p>

          <p className="text-[13px] text-[var(--text-subtle)] pt-4 border-t border-[var(--border)] w-full" data-id="element-67">
            © 2025 <span className="text-[var(--blue)]" data-id="element-68">Oriam Marketing</span>.
            Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}